module.exports = __webpack_public_path__ + "static/media/alexandraGate.f0b1dd65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/alexandraGate.jpg
// module id = 299
// module chunks = 0